import { render, staticRenderFns } from "./AuthRedirect.vue?vue&type=template&id=519ccd70&"
import script from "./AuthRedirect.vue?vue&type=script&lang=js&"
export * from "./AuthRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports